import { render, staticRenderFns } from "./DataTableVisualizeButton.vue?vue&type=template&id=b5f97178&scoped=true&"
import script from "./DataTableVisualizeButton.vue?vue&type=script&lang=js&"
export * from "./DataTableVisualizeButton.vue?vue&type=script&lang=js&"
import style0 from "./DataTableVisualizeButton.vue?vue&type=style&index=0&id=b5f97178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f97178",
  null
  
)

export default component.exports